<div class="modal-content modal-content1">
  <div class="modal-body">
    <mat-tab-group animationDuration="0ms">
      <form [formGroup]="signaturePadForm">
        <mat-tab class="tab">
          <ng-template mat-tab-label class="active">
            <div class="font-weight-bold">
              <i class="fas fa-image"></i> Agregar imagen
            </div>
          </ng-template>
          <div class="host">
            <div class="custom-file">
              <input type="file"
                     class="custom-file-input"
                     accept="image/jpeg, image/png"
                     alife-file-to-base64
                     id="customRubricFile"
                     (change)="readSelectedRubric($event)"
                     (onFileChanged)="changeStatus($event)">
              <small *ngIf="isInvalidControl('rubricFilename2Show')"
                     class="text-danger">
                {{ "MESSAGE.SELECT-RUBRIC" | translate }}
              </small>
              <div class="custom-file-label">
                <label for="customRubricFile">
                  {{signaturePadForm.get('rubricFilename2Show').value ? signaturePadForm.get('rubricFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                </label>
              </div>
            </div>
            <div class="host ng-star-inserted">
              <label for="customRubricFile" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
              <div>
                <img [src]="defaultRubricSrc" style="{{styleDimensionsRubric}}" alt="Rubric">
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <button class="btn btn-outline-success w-100"
                        [disabled]="!isReady2Save"
                        (click)="saveSignature()">
                  <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
                </button>
              </div>
              <div class="col-6">
                <button class="btn btn-outline-danger w-100" (click)="cancel()">
                  <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab class="tab">
          <ng-template mat-tab-label>
            <div class="font-weight-bold">
              <i class="fas fa-pen"></i> Dibujar
            </div>
          </ng-template>
          <div class="host">
            <canvas #canvas width="350" height="200" (mousedown)="startDrawing($event)" (mousemove)="draw($event)"
                    (mouseup)="stopDrawing()" (mouseleave)="stopDrawing()"></canvas>
            <div class="row mt-2 mt-2 mt-2-custom">
              <div class="col-3 offset-md-9">
                <label (click)="clearSignature()" class="col-form-label"
                       style="color: #dc3545;">
                  <i class="fas fa-trash"></i> {{ "LABEL.ERASE" | translate }}
                </label>
              </div>
            </div>
            <div class="row mt-2 mt-2-custom">
              <div class="col-6">
                <label for="lineWitdh" class="col-form-label">{{ "LABEL.SIZE" | translate }}</label>
                <select class="form-control"
                        id="lineWitdh"
                        formControlName="lineWitdh"
                        [(ngModel)]="lineWitdh">
                  <option [value]=4>4</option>
                  <option [value]=5>5</option>
                  <option [value]=6>6</option>
                  <option [value]=7>7</option>
                  <option [value]=8>8</option>
                  <option [value]=9>9</option>
                </select>
              </div>
              <div class="col-6">
                <label for="strokeColor" class="col-form-label">{{ "LABEL.COLOR" | translate }}</label>
                <select class="form-control"
                        id="strokeColor"
                        formControlName="strokeColor"
                        [(ngModel)]="strokeColor">
                  <option value="black">negro</option>
                  <option value="green">verde</option>
                  <option ngValue="blue">azul</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <button class="btn btn-outline-success w-100"
                        [disabled]="!isDrawComplete"
                        (click)="saveDrawSignature()">
                  <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
                </button>
              </div>
              <div class="col-6">
                <button class="btn btn-outline-danger w-100" (click)="cancel()">
                  <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </div>
        </mat-tab>
      </form>
    </mat-tab-group>
  </div>
</div>
